// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col___4OEC","checkboxCol":"Table_checkboxCol__rmPII","emailCol":"Table_emailCol__2cxYS","actionCol":"Table_actionCol__fot20"};